import { AxiosError } from 'axios';
import {
  newPasswordProtectedApi,
  PasswordProtectionsApi,
} from '../api/backend/api';

export interface AuthenticationResponse {
  isAuthenticate: boolean;
}

export class PasswordProtectionRepository {
  constructor(private api: PasswordProtectionsApi) {}

  public async Authentication(
    resourceType: string,
    resourcePublicId: number,
    password: string,
  ): Promise<AuthenticationResponse> {
    const q = {
      resourceType,
      resourcePublicId,
      password,
    };

    return this.api
      .passwordAuthetication(q)
      .then(res => {
        return {
          isAuthenticate: res.data.isAuthenticate,
        };
      })
      .catch((err: AxiosError) => {
        // TODO handle error by status
        return Promise.reject(err);
      })
      .catch((err: Error) => {
        return Promise.reject(err);
      });
  }
}

export default function(session?: string, token?: string) {
  return new PasswordProtectionRepository(
    newPasswordProtectedApi(session, token),
  );
}
